import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { FluentProvider, webLightTheme } from '@fluentui/react-components'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import App from './App'
import { ErrorBoundary } from './components'
import { AuthProvider } from './auth'
import { IssueRepositoryProvider, issueRepository } from './data'
import { ExperienceModeProvider } from './context/ExperienceModeContext'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <FluentProvider theme={webLightTheme}>
          <QueryClientProvider client={queryClient}>
            <ExperienceModeProvider>
              <IssueRepositoryProvider repository={issueRepository}>
                <ErrorBoundary>
                  <App />
                </ErrorBoundary>
              </IssueRepositoryProvider>
            </ExperienceModeProvider>
          </QueryClientProvider>
        </FluentProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
